"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.splitFormDataByFile = splitFormDataByFile;
/**
 * Split a multi-file FormData into one FormData per file.
 *
 * The upload endpoint reads a single `file` field, so posting several parts under
 * that one name makes PHP keep only the last and silently drop the rest. Callers
 * upload each of these separately instead.
 */
function splitFormDataByFile(formData, fieldName) {
    if (fieldName === void 0) { fieldName = "file"; }
    return formData
        .getAll(fieldName)
        .filter(function (entry) { return entry instanceof File; })
        .map(function (file) {
        var singleFileFormData = new FormData();
        singleFileFormData.append(fieldName, file, file.name);
        return singleFileFormData;
    });
}
